import { render, staticRenderFns } from "./SheetBackupDownload.vue?vue&type=template&id=3e4ad646&scoped=true"
import script from "./SheetBackupDownload.vue?vue&type=script&lang=js"
export * from "./SheetBackupDownload.vue?vue&type=script&lang=js"
import style0 from "./SheetBackupDownload.vue?vue&type=style&index=0&id=3e4ad646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4ad646",
  null
  
)

export default component.exports